import { localDateAndTime, hourFromTime } from "../../../services/time-service"
export const orderLogViews = self => ({
  get logCreatedAt() {
    return localDateAndTime(self.createdAt)
  },
})